export const ChamberTypes = {
  1: '5',
  2: '6',
  3: '7'
}
